import { NgModule, inject } from '@angular/core';
import { MatIconRegistry, MatIconModule } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser'

@NgModule({
  imports: [
    MatIconModule,
  ],
  declarations: []
})
export class PcscolIconsModule {
  private iconRegistry = inject(MatIconRegistry);

  constructor() {
    const iconRegistry = this.iconRegistry;
    const sanitaizer = inject(DomSanitizer);

    this._fix5188();
    iconRegistry.addSvgIconSet(sanitaizer.bypassSecurityTrustResourceUrl('assets/img/pcscol-icon-pack.svg'));
    iconRegistry.addSvgIconSet(sanitaizer.bypassSecurityTrustResourceUrl('assets/img/symbol-defs.svg'));
    iconRegistry.addSvgIconSet(sanitaizer.bypassSecurityTrustResourceUrl('assets/img/icons-pack-pieces.svg'));
  }

  /** temporary fix for
    → https://github.com/angular/material2/issues/5188
    symbol's viewBox/preserveAspectRatio should be
    preserved when copying svg from iconRegistry.
    otherwise, they can't be properly scaled when needed.
  */
  private _fix5188() {
    /* decorate original MatIconRegistry#_toSvgElement() */
    const proto = Object.getPrototypeOf(this.iconRegistry);
    const original: ((e: Element) => Element) = proto._toSvgElement;
    proto._toSvgElement = (element: Element) => {
        const svg = original.call(this.iconRegistry, element);
        const viewBox = element.getAttribute('viewBox');
        if (viewBox) {
            svg.setAttribute('viewBox', viewBox);
        }
        const preserveAspectRatio = element.getAttribute('preserveAspectRatio');
        if (preserveAspectRatio) {
            svg.setAttribute('preserveAspectRatio', preserveAspectRatio);
        }
        return svg;
    };
  }
 }
